var _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWalletIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.8929 11.5H23V14.7857H18.8929C18.675 14.7857 18.4661 14.6992 18.312 14.5451C18.158 14.3911 18.0714 14.1821 18.0714 13.9643V12.3214C18.0714 12.1036 18.158 11.8946 18.312 11.7406C18.4661 11.5865 18.675 11.5 18.8929 11.5ZM18.8929 16.4286C18.2393 16.4286 17.6125 16.1689 17.1503 15.7068C16.6882 15.2447 16.4286 14.6179 16.4286 13.9643V12.3214C16.4286 11.6679 16.6882 11.0411 17.1503 10.5789C17.6125 10.1168 18.2393 9.85714 18.8929 9.85714H23V9.03571C22.9987 7.94683 22.5656 6.90292 21.7956 6.13297C21.0257 5.36301 19.9817 4.92988 18.8929 4.92857H3.28571C3.17533 4.92851 3.06524 4.91723 2.95714 4.89489C2.149 4.81534 1.39914 4.43868 0.85282 3.83788C0.306501 3.23708 0.00260495 2.4549 0 1.64286V18.8929C0.00130431 19.9817 0.434439 21.0257 1.20439 21.7956C1.97435 22.5656 3.01826 22.9987 4.10714 23H18.8929C19.9817 22.9987 21.0257 22.5656 21.7956 21.7956C22.5656 21.0257 22.9987 19.9817 23 18.8929V16.4286H18.8929ZM19.7143 3.28571C19.7143 2.41429 19.3681 1.57855 18.7519 0.962364C18.1357 0.346173 17.3 0 16.4286 0H2.46429C2.02857 0 1.61071 0.173086 1.30261 0.481182C0.994515 0.789277 0.821429 1.20714 0.821429 1.64286C0.821429 2.29643 1.08106 2.92323 1.5432 3.38537C2.00534 3.84751 2.63215 4.10714 3.28571 4.10714H19.7143V3.28571Z",
    fill: "url(#paint0_linear_167_3601)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_167_3601",
    x1: -3,
    y1: -1.16618e-8,
    x2: 23,
    y2: 23,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5149B5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7670CF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWalletIcon);
export default __webpack_public_path__ + "static/media/WalletIcon.6ba7a7954cefec7f6c770d9532662c72.svg";
export { ForwardRef as ReactComponent };